import { SignalDoc, SignalType } from "@megaron/docs-contracts";

import { SignalDocumentGroup, groupSignals } from "./groupSignals";

const persistentSignalTypes: ReadonlySet<string> = new Set<SignalType>([
  "regionCustomerMissingPhone",
  "posCustomerMissingGooglePlaceId",
  "regionCustomerMissingEmail",
  "draftInvoice",
  "loyaltyAdminOrderCreated",
]);

export const isPersistentSignal = (signal: SignalDoc): boolean =>
  persistentSignalTypes.has(signal.signalType);

const legacyTicketBadgeSignalTypes = new Set(["unreadAccessibleTicket"]);
const legacyInvoiceBadgeSignalTypes = new Set(["unreadAccessibleInvoice"]);

const matchesBadgeSignalType = (signal: SignalDoc, allowedTypes: ReadonlySet<string>): boolean => {
  if (allowedTypes.has(signal.signalType)) return true;
  if (allowedTypes.has("unreadTicket") && legacyTicketBadgeSignalTypes.has(signal.signalType)) return true;
  if (allowedTypes.has("unreadInvoice") && legacyInvoiceBadgeSignalTypes.has(signal.signalType)) return true;
  return false;
};

const isBadgeGroup = (group: SignalDocumentGroup, badgeSignalTypes: ReadonlySet<string>): boolean => {
  const badgeSignals = group.signals.filter((signal) => matchesBadgeSignalType(signal, badgeSignalTypes));
  if (badgeSignals.length === 0) return false;
  if (badgeSignals.some(isPersistentSignal)) return true;
  return badgeSignals.some((signal) => !signal.isRead);
};

export const navBadgeGroupCount = (
  signals: SignalDoc[],
  badgeSignalTypes: readonly SignalType[],
): number => {
  if (badgeSignalTypes.length === 0) return 0;

  const allowedTypes = new Set<string>(badgeSignalTypes);
  return groupSignals(signals).filter((group) => isBadgeGroup(group, allowedTypes)).length;
};

export const filterDismissibleDocIds = (
  docIds: SignalDoc["docId"][],
  signals: SignalDoc[],
): SignalDoc["docId"][] => {
  const signalsByDocId = new Map(signals.map((signal) => [signal.docId, signal]));

  return docIds.filter((docId) => {
    const signal = signalsByDocId.get(docId);
    return signal !== undefined && !isPersistentSignal(signal);
  });
};
